import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import BannerReportAnalitycsV2 from './BannerReportAnalitycsV2'
import BannerReportAnalitycsV1 from './BannerReportAnalitycsV1'
import BannerReportAnalitycsImage from './BannerReportAnalitycsImage'
import Wrapper from '../wrapper/'

const styles = theme => ({
  bannerOverlay: {
    padding: 32,
    height: 179,
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 32,
    backgroundColor: 'rgb(136, 102, 255)',
  },
})

class BannerReportAnalitycsBrick extends Component {
  render() {
    const {
      classes,
      isDemo,
      isConfig,
      isFetching,
      getData,
      getSetting,
    } = this.props

    return (
      <Wrapper
        shadow={2}
        className={classes.bannerOverlay}
        style={{
          display: isDemo ? 'none' : 'block',
        }}
      >
        <div style={{ display: 'flex' }}>
          <BannerReportAnalitycsImage />
          <BannerReportAnalitycsV1/>
        </div>
      </Wrapper>
    )
  }
}

export default withStyles(styles)(BannerReportAnalitycsBrick)
